//import './reactApp.jsx';
// import '../sass/style.scss';
// import add from './add.ts';

// `init.js`をESM形式でインポート
import Init from "./init.js";

// console.log(add(3, 9));
Init.init();
